import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg, fmt } from "@/lib/api";
import { CopyField } from "@/components/CopyField";
import { useCountdown, fmtTime } from "@/components/Countdown";

const Payment = ({ dep, onDone }) => {
  const left = useCountdown(dep.expires_at);
  const [loading, setLoading] = useState(false);
  const sent = async () => {
    setLoading(true);
    try {
      await api.post(`/wallet/deposit/${dep.id}/sent`);
      toast.success("Talebiniz alındı. Onaylandığında bakiyenize eklenecek.");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setLoading(false);
  };
  return (
    <div className="space-y-4 x-rise" data-testid="bank-payment-page">
      <div className="x-panel p-4 flex items-center justify-between">
        <div>
          <div className="text-[13px] text-[var(--x-muted)] font-semibold">Gönderilecek Tutar</div>
          <div data-testid="bank-payment-amount" className="text-2xl font-black tabular-nums">₺{fmt(dep.amount_try)}</div>
        </div>
        <div className="text-right">
          <div className="text-[12px] text-[var(--x-muted)] font-semibold">Kalan Süre</div>
          <div data-testid="bank-countdown" className={`font-mono text-2xl font-extrabold tabular-nums ${left < 60 ? "text-[var(--x-red)]" : ""}`}>{fmtTime(left)}</div>
        </div>
      </div>
      <CopyField label="Banka Adı" value={dep.bank_name} testId="bank-name" />
      <CopyField label="Ad Soyad" value={dep.holder} testId="bank-holder" />
      <CopyField label="IBAN" value={dep.iban} testId="bank-iban" mono />
      <CopyField label="Tutar" value={dep.amount_try} testId="bank-amount" />
      {left > 0 ? (
        <button data-testid="bank-sent-btn" disabled={loading} onClick={sent} className="x-btn x-btn-green w-full py-3.5">
          {loading && <Loader2 size={18} className="animate-spin" />} Gönderimi Yaptım
        </button>
      ) : (
        <div className="text-center text-[var(--x-red)] font-bold" data-testid="bank-expired">Süre doldu. Lütfen yeni talep oluşturun.</div>
      )}
    </div>
  );
};

export const DepositBank = ({ onDone }) => {
  const [cfg, setCfg] = useState(null);
  const [amount, setAmount] = useState("");
  const [dep, setDep] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/wallet/config").then((r) => setCfg(r.data));
  }, []);

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/wallet/deposit/bank", { amount_try: Number(amount) });
      setDep(data);
    } catch (e) {
      toast.error(errMsg(e));
    }
    setLoading(false);
  };

  if (dep) return <Payment dep={dep} onDone={onDone} />;

  return (
    <div className="space-y-5 x-rise">
      <div>
        <span className="x-label">Yatırım Tutarı (TL)</span>
        <div className="relative">
          <input data-testid="bank-deposit-amount-input" type="number" inputMode="decimal" className="x-input pr-10" placeholder={`Min. ${cfg?.min_deposit ?? ""}`} value={amount} onChange={(e) => setAmount(e.target.value)} />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--x-muted)] font-bold">₺</span>
        </div>
        <div className="flex gap-2 mt-2">
          {[250, 500, 1000, 2500].map((v) => (
            <button key={v} type="button" onClick={() => setAmount(String(v))} className="x-btn x-btn-secondary px-3 py-1.5 text-[13px]">₺{fmt(v, 0)}</button>
          ))}
        </div>
      </div>
      <button data-testid="bank-deposit-submit-btn" disabled={!amount || loading} onClick={submit} className="x-btn x-btn-primary w-full py-3.5">
        {loading && <Loader2 size={18} className="animate-spin" />} Devam Et
      </button>
    </div>
  );
};
